<template>
  <div class="action-sort-container" :class="device.isMobile ? 'action-sort-container-mobile' : ''">
    <div class="reset" @click.stop="reset"></div>
    <div class="action-content">
      <div class="action-list">
        <div
          class="action-item"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <draggable
            class="action-drop"
            :sort="false"
            :disabled="false"
            :group="{
              name: content.key,
              pull: false,
              put: dropChecked(item)
            }"
            @add="dropHandle($event, item, index)"
            v-model="item.newArr"
          >
            <div class="action-drop-box">
              <div v-if="item.newArr[0]" class="action-drop-result">{{ item.newArr[0].answerLable }}</div>
            </div>
          </draggable>
          <div class="action-cover">
            <img :src="item.cover" :alt="item.title" :title="item.title">
          </div>
          <div class="isTrue" v-if="item.isTrue">{{ item.title }}</div>
          <div class="isTrue" v-else></div>
        </div>
      </div>
    </div>
    <div class="action-handle">
      <div
        v-for="item in handleShowData"
        :key="item.key"
        class="action-handle-item"
      >
        <draggable
          :sort="false"
          :group="{
            name: content.key,
            pull: true,
            put: false
          }"
          v-model="handleData"
          @start="dragstartHandle"
        >
          <template v-for="it in handleData">
            <div :key="`${it.key}-1`" v-if="it.key === item.key && !item.isSelect" class="action-handle-label action-handle-label-drag">{{ it.answerLable }}</div>
          </template>
        </draggable>
        <div class="action-handle-label action-handle-label-active">{{ item.answerLable }}</div>
        <div class="action-handle-text" @click.stop="previewPDF(item.pdfUrl)">{{ item.text }}</div>
      </div>
    </div>
    <el-dialog
      class="pdf-dialog"
      :class="device.isMobile ? 'pdf-dialog-mobile' : ''"
      title=""
      :visible.sync="pdfDialogVisible"
      :append-to-body="true"
      :before-close="dialogClose"
      v-if="pdfDialogVisible"
    >
      <div class="pdf-dialog-container">
        <div class="pdf-action">
          <div class="pdf-tab-button">
            <div class="btn-def btn-pre" @click.stop="prePage">上一页</div>
            <div class="btn-def btn-next" @click.stop="nextPage">下一页</div>
            <!-- <div class="btn-def" @click.stop="clock">顺时针</div>
            <div class="btn-def" @click.stop="counterClock">逆时针</div> -->
            <div class="btn-def" @click.stop="scaleD">放大</div>
            <div class="btn-def" @click.stop="scales">缩小</div>
          </div>
          <div class="page-size">{{ pageNum }}/{{ pageTotalNum }}</div>
        </div>
        <div class="pdf-content">
          <div>
            <div class="pdf-box" ref="pdf">
              <pdf
                :src="pdfUrl"
                :page="pageNum"
                :rotate="pageRotate"
                @num-pages="pageTotalNum = $event"
                @link-clicked="page = $event"
              ></pdf>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*
交互动作组件 -- 排一排
*/
import pdf from 'vue-pdf'
import draggable from "vuedraggable";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "sortAction",
  components: {
    draggable,
    pdf
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      resultData: [],
      handleData: [],
      handleShowData: [],
      isComplete: false,
      historyData: null,
      dragKey: '',
      dragIndex: 0,
      pdfDialogVisible: false,
      pdfUrl: '',
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      customHeight: 400, // 自定义的PDF预览框高度
      scale: 100,
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {})
    let historyData = this.historyData[this.content.key]
    // this.resultData = this.content.answerData.map((answer, index) => {
    //   let returnData = this.content.sortData.find(sort => {
    //     return sort.answerKey == answer
    //   });
      
    //   returnData = JSON.parse(JSON.stringify(returnData))
    //   returnData.newArr = []
    //   if(historyData && historyData[index]) {
    //     returnData.isTrue = 1
    //     returnData.newArr.push(returnData)
    //   }
    //   return returnData
    // })
    this.resultData = this.content.sortData.map((item, index) => {
      let returnData = item
      
      returnData = JSON.parse(JSON.stringify(returnData))
      returnData.newArr = []
      if(historyData && historyData[index]) {
        let historyObj = this.content.answerData.find(it => it.answerKey === item.answerKey);
        returnData.isTrue = 1
        returnData.newArr.push(historyObj)
      }
      return returnData
    })
    console.log(this.resultData)

    this.handleData = this.content.answerData;
    this.handleShowData = this.content.answerData.map(item => {
      let returnData = item
      let resultData = this.resultData.find(it => it.answerKey === returnData.answerKey)
      console.log('resultData', resultData)
      if(resultData.newArr.length > 0) {
        returnData.isSelect = 1
      }
      return returnData
    });
    console.log(this.handleData)
    console.log(this.handleShowData)
    // this.handleData = this.content.sortData.filter(item => {
    //   return !(historyData && historyData.includes(item.key))
    // });
    this.isCompleteFn();
  },
  methods: {
    // 开始拖拽记录拖拽的元素
    dragstartHandle(e) {
      let handleData = this.handleData[e.oldIndex];
      console.log(e.oldIndex, handleData)
      this.dragKey = handleData.answerKey;
      this.dragIndex = e.oldIndex;
      console.log(this.dragKey, this.dragIndex)
    },
    // 是否可以拖入的判断
    dropChecked(item) {
      if(item.newArr.length > 0) return false;
      return true
    },
    // 拖拽直接显示正确答案，不正确的拖拽不进去
    dropHandle(e, item, index) {
      console.log('drop', index)
      let handleIndex = this.dragIndex
      let resultIndex = index
      
      if(this.resultData[resultIndex].newArr[0].answerKey !== this.resultData[resultIndex].answerKey) {
        let changeData = this.resultData[resultIndex].newArr[0]
        this.$set(this.resultData[resultIndex], 'newArr', [])
        this.handleData.splice(handleIndex, 0, changeData)
        this.$forceUpdate()
        return false
      }

      this.$set(this.resultData[resultIndex], 'isTrue', 1)
      this.isCompleteFn();
      
      let historyData = {}
      historyData[this.content.key] = this.resultData.map(result => (result.newArr[0] || {}).key);
      this.historyData = Object.assign({}, this.historyData, historyData)
      setActionData(JSON.stringify(this.historyData));
    },
    dragstartHandle1(e, item, dragType) {
      item.dragType = dragType;
      e.dataTransfer.setData("content", JSON.stringify(item));
    },
    // 拖拽直接显示正确答案，不正确的拖拽不进去
    dropHandle1(e, item, index) {
      let data = e.dataTransfer.getData("content");
      data = JSON.parse(data)
      if(data.actionKey !== this.content.key) {
        return false
      }
      if(data.dragType === 'handle') {
        console.log(data, this.content.answerData[index])
        if(data.answerKey === this.content.answerData[index]) {
          if(this.resultData[index].key) {
            let handleShowIndex = this.handleData.findIndex(i => i.key === item.key)
            this.$set(this.handleData[handleShowIndex], 'hideInHandle', false)
          }
          // 从数据栏拖拽到操作栏，隐藏已经加入过的数据栏的数据
          this.$set(this.resultData, index, data)
          this.$set(this.resultData[index], 'mark', 'right')
          this.$set(this.resultData[index], 'isTrue', 1)
          let handleIndex = this.handleData.findIndex(i => i.key === data.key)
          this.$set(this.handleData[handleIndex], 'hideInHandle', true)
          // 判断是否全部完成
          this.isCompleteFn();
          
          let historyData = {}
          historyData[this.content.key] = this.resultData.map(item => item.answerKey);
          this.historyData = Object.assign({}, this.historyData, historyData)
          setActionData(JSON.stringify(this.historyData));
        }
      }
    },
    // 判断是否全部完成
    isCompleteFn() {
      let isComplete = true;
      this.resultData.forEach(i => {
        if(i.isTrue !== 1) {
          isComplete = false
          return
        }
      })
      this.isComplete = isComplete;
    },
    // 重置整个内容
    reset() {
      this.resultData = this.content.sortData.map((item, index) => {
        let returnData = item
        
        returnData = JSON.parse(JSON.stringify(returnData))
        returnData.newArr = []
        return returnData
      })

      this.handleData = this.content.answerData;
      this.handleShowData = this.content.answerData.map(item => {
        let returnData = item
        returnData.isSelect = 0
        return returnData
      });
      
      this.isComplete = false;
      delete this.historyData[this.content.key]
      setActionData(JSON.stringify(this.historyData));
    },
    previewPDF(url) {
      this.pdfUrl = url;
      this.pageNum = 1;
      this.scale = 100;
      this.pdfDialogVisible = true;
    },
    dialogClose() {
      this.pdfUrl = '';
      this.pageNum = 1;
      this.scale = 100;
      this.$refs.pdf.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.style.height = parseInt(this.scale) + "%";
      this.$nextTick(() => {
        setTimeout(() => {
          this.pdfDialogVisible = false;
        })
      })
    },
    //上一页
    prePage() {
      var p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
    },
    // 下一页
    nextPage() {
      var p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
    },
    //顺时针
    clock() {
      this.pageRotate += 90;
    },
    //逆时针
    counterClock() {
      this.pageRotate -= 90;
    },
    /** PDF放大 */
    scaleD() {
      if(this.scale>150) return false
      this.scale += 10;
      this.$refs.pdf.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.style.height = parseInt(this.scale) + "%";
    },
    /** PDF缩小 */
    scales() {
      if(this.scale<40) return false
      this.scale -= 10;
      this.$refs.pdf.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.style.height = parseInt(this.scale) + "%";
    },
  },
}
</script>


<style lang="scss" scoped>
.action-sort-container{
  padding: 0 20rem;

  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -10rem;
    right: 20rem;
    cursor: pointer;
  }

  .action-content{
    margin: 0 auto;

    .action-list{
      display: flex;
      flex-wrap: wrap;
      padding: 20rem 0;

      .action-item{
        width: 210rem;
        border-radius: 6rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        position: relative;
        margin-right: 12rem;

        .action-drop{
          width: 210rem;
          height: 225rem;
          border-radius: 6rem;
          position: relative;
          z-index: 5;

          .action-handle-label{
            display: none;
          }

          .action-drop-box{
            width: 100%;
            height: 100%;
            position: relative;

            .action-drop-result{
              width: 40rem;
              height: 40rem;
              position: absolute;
              top: 0;
              left: 0;
              background: #5CA683;
              border-radius: 50%;
              font-size: 28rem;
              line-height: 40rem;
              text-align: center;
              color: #fff;
              font-family: Calibri;
            }
          }
        }

        .action-cover{
          position: absolute;
          top: 0;
          left: 0;

          img{
            display: block;
            max-width: 210rem;
            max-height: 225rem;
          }
        }
  
        .isTrue{
          font-size: 16rem;
          color: #999;
          line-height: 26rem;
          height: 26rem;
          padding: 10rem 0;
        }
        
        &:nth-child(3n){
          margin-right: 0;
        }
      }
  
      .item-has-sort{
        border: 2rem solid transparent;
      }
    }
  }


  .action-handle{
    min-height: 80rem;
    margin-top: 20rem;

    .action-handle-item{
      margin-right: 12rem;
      display: flex;
      align-items: center;
      margin-bottom: 23rem;
      position: relative;

      .action-handle-label{
        width: 40rem;
        height: 40rem;
        background: #5CA683;
        border-radius: 50%;
        line-height: 40rem;
        text-align: center;
        font-size: 28rem;
        color: #fff;
        margin-right: 20rem;
      }
      .action-handle-label-active{
        opacity: 0.5;
      }

      .action-handle-label-drag{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
      }

      .action-handle-text{
        font-size: 28rem;
        color: #0482EC;
        line-height: 36rem;
        font-family: Calibri;
        cursor: pointer;
      }
    }
  }

  .anwser{
    font-size: 16rem;
    color: #333;
    line-height: 24rem;
    display: flex;
    margin-top: 20rem;

    .anwser-title{
      white-space: nowrap;
      margin-right: 20rem;
    }
  }
}

.action-sort-container-mobile{
  .reset{
    width: 44rem;
    height: 44rem;
  }
}

.pdf-dialog{
  /deep/.el-dialog{
    height: 85%;
    overflow: hidden;

    .el-dialog__body{
      overflow: hidden;
    }
  }
  .pdf-dialog-container{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .pdf-action{
      flex: 0 0 80rem;

      .pdf-tab-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 10rem;

        .btn-def {
          width: 98rem;
          height: 40rem;
          line-height: 40rem;
          text-align: center;
          color: #fff;
          background-color: #f48450;
          border-color: #f48450;
          border-radius: 5rem;
          font-size: 18rem;
        }
      }

      .page-size{
        text-align: center;
      }
    }

    .pdf-content{
      flex: 1;
      overflow: auto;

      .pdf-box{
        overflow: hidden;
      }
    }
  }
}
.pdf-dialog-mobile{
  /deep/.el-dialog{
    height: 85%;
    width: 100vw;
  }
}
</style>